export const REQUEST_EDIT_PROVIDER_MODAL_FIELD_NAME_PROVIDERS = 'providers'

export const REQUEST_EDIT_PROVIDER_MODAL_PAYLOAD_FIELD_NAME = 'ids'

export const REQUEST_EDIT_PROVIDER_MODAL_QA_NAME = 'editProvider'

export const REQUEST_EDIT_PROVIDER_MODAL_USERS_PARAMS = [
  ['with_field', 'email'],
  ['with_field', 'avatar'],
]
